import { Model } from '../../interfaces/pages/project'

export type Type = Model & { saving?: boolean }

export const initial: Type = {
  loading: true,
  project: null,
  error: null,

  creativeAction: {
    inProgress: false,
    message: null,
  },
  platforms: [],
}
